<div>
  <div class="tool-description">
    The help page displays information about how each tool can be used and how
    to navigate through the dashboard. The Tools Support card contains
    information about how each tool can be utilize where as the Navigation
    Support card contains information about how to navigate to each tool.
  </div>

  <div class="goals-wrapper">
    <goals-list
      [goalsList]="toolListService.getHelpHomepageCards()"
      [showMoreInfoIcon]="false"
    ></goals-list>
  </div>
</div>
